import Label from "components/general/Label";
import SportCode from "components/common/SportCode";
import { getRscObject } from "helpers/rsc";
import { RscFromStore } from "helpers/utils";
import HorseIcon from "./HorseIcon";


export function ColumnHorseIcons({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-20',
    label = '',
    remove = false
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'sortOrder',
            id: 'HorseIcons',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            Cell: (props) => {
                const athsData = props.cell.row.original?.teamAthletes?.sort((a, b) => a?.order - b?.order)
                const icons = athsData?.map(ath => <HorseIcon ath={ath} key={ath.athlete.code} />)
                return (<>{icons}</>);
            }
        }
    )
}

export function ColumnIrmOrExtendedResult({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    label = 'HeaderNone',
    remove = false,
    id = 'er',
    code = '',
    type = 'ER',
    dataSource = 'er_value'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => {
                const er = props?.extendedResults?.find(er => er?.er_code === code && er?.er_type === type);
                return er ? er[dataSource] : '';
            },
            id: id,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original;
                const irmCode =  props.cell.row.original.resultIrm;
                const irm = irmCode ? <SportCode discipline={getRscObject(RscFromStore()).discipline} entity='@IRM' code={irmCode} abbr={true} isAddLegend={true} /> : undefined;
                let er = row?.extendedResults?.find(er => er?.er_code === code && er?.er_type === type);
                er = er ? er[dataSource] : ''
                return irmCode ? irm : er;
            }
        }
    )
}

export function ColumnTeamMember({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-1',
    label = '',
    remove = false,
}) {
    return (
        {
            Header: '',
            id: 'TeamMember',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original;
                //console.log(row?.eventUnitEntries?.find(eu => eu?.eue_code === 'TEAM_MEMBER'))
                const value = row?.eventUnitEntries?.find(eu => eu?.eue_code === 'TEAM_MEMBER')?.eue_value;
                return value === 'Y' ? 'T' : '';
            }
        }
    )
}
